<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>

  body {
    margin: 0;
    padding: 0;
  }

  ul, li {
    padding: 0;
    margin: 0;
    list-style-type: none;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .el-breadcrumb {
    padding: 10px;
    background: #EDF2FC;
  }

  .page {
    margin: 10px;
    float: right;
  }

  .help-block {
    color: #878D99;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue